import baseSearchOptions from 'vue-src/store/modules/persistent/modules/_baseSearchOptions'

const DEFAULT_SORT = 'stock_number'

export default baseSearchOptions({
  state:{
    sort: DEFAULT_SORT,
  },
  getters: {
    getCurrentSort(state, getters) {
      if (['_score', '_source'].includes(state.sort)) {
        return DEFAULT_SORT
      }
      return state.sort
    }
  }
})



// WEBPACK FOOTER //
// ./ixcms/themes/jedco/src/vue-src/store/modules/persistent/modules/mxcategoryItems.js